<template>
    <div>
     <header>
      <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white">
        <div class="container">
          <a class="navbar-brand" href="index.html" id="nav-logo">
            <img src="images/logo/logo.webp" alt="logo-brand">
          </a>

          <button class="navbar-toggler hamburger hamburger--3dy-r" type="button" data-toggle="collapse"
            data-target="#navbarButton" aria-controls="navbarButton" aria-expanded="false" aria-label="Toggle navigation">
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>

          <div class="collapse navbar-collapse" id="navbarButton">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <a class="nav-link" href="#profile">Tentang Atozpay</a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">Layanan</a>

                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" href="https://atozpay.co.id/" target="_blank" rel="noopener">
                    <img class="pr-1" src="images/icon/icon-atozpay.png" alt="icon-logo">
                    Atozpay
                  </a>
                  <a class="dropdown-item" href="https://atozgo.co.id/" target="_blank" rel="noopener">
                    <img class="pr-1" src="images/icon/icon-atozgo.png" alt="icon-logo">
                    Atozgo
                  </a>
                  <a class="dropdown-item" href="https://agen.atozpay.co.id/">
                    <img class="pr-1" src="images/icon/icon-atozagen.png" alt="icon-logo">
                    Atozpay Agen
                  </a>
                  <a class="dropdown-item" href="https://www.createapp.com/" target="_blank" rel="noopener">
                    <img class="pr-1" src="images/icon/icon-createapp.png" alt="icon-logo">
                    Atozpay Createapp
                  </a>
                </div>
              </li>

              <li class="nav-item">
                <a class="nav-link" href="#underconstruction" title="underconstruction">Promo & Blog</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#underconstruction" title="underconstruction">Bantuan</a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle disabled" href="#" id="multi" role="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false"><i class="fas fa-globe"></i>
                  Bahasa Indonesia</a>
                <div class="dropdown-menu" aria-labelledby="multi">
                  <a class="dropdown-item" href="#">English</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <Slideshow />

      </header>
    </div>
</template>

<script>

import Slideshow from '@/components/Slideshow.vue';

    export default {
        name: "Header",
        components:{
          Slideshow
        }
    }
</script>

<style scoped>

</style>